<!--eslint-disable-->
<template>
    <el-dialog :visible.sync="formVisible" @close="closeDialog" @open="openDialog" width="1200px">
        <template slot="title">
            <div class="header-container">
                <span class="main-title">Arquivos</span>
            </div>
        </template>
        
        <el-row v-for="(page, index) of pages" :key="index" >
            <el-col :span="6" v-for="(item, innerindex) of page" :key="item.name" :offset="innerindex > 0 ? 2 : 1">
                <el-card :body-style="{ padding: '0px' }">
                    <embed :src="item.url" type="application/pdf">
                    <a :href="item.url" target="_blank">
                        <div style="padding: 14px; cursor: pointer;">
                            <div class="main-card">
                                <span>{{ item.name }}</span>
                            </div>
                            <div class="detail-card">
                                <span>{{ item.data }}</span>
                            </div>
                        </div>
                    </a>
                </el-card>
            </el-col>
        </el-row>
        
        <span slot="footer">
            <el-button @click="closeDialog">Cancelar</el-button>
        </span>
    </el-dialog>
</template>

<script>
/*eslint-disable*/
import fb from "@/services/firebaseConfig"
import firebase from "firebase/app"
import regex from "@/services/regex"
import {mask} from 'vue-the-mask'
import validators from "@/services/validators"

const db = fb.db

export default {
    data() {
        return {
            files: [],
            filesTable: []
        }
    },
    directives: {
        mask
    },
    props: {
        filesDialogVisible: Boolean,
        urls: Array
    },
    methods: {
        closeDialog() {
            this.files = []
            this.$emit('closeDialog');
        },
        openDialog() {
            this.fillFiles(this.urls)
        },
        fillFiles(urls) {
            
            urls.forEach(url => {
                let ref = firebase.storage().refFromURL(url)
                
                let nameArray = ref.name.split('_')
                let timestamp = nameArray.pop()
                let data = new Date(parseInt(timestamp)).toLocaleString()
                let filename = nameArray.join('_')
                
                this.files.push({name: filename, url: url, data: data})
            })
        },
    },
    computed: {
        formVisible: {
            get() {
                return this.filesDialogVisible
            },
            set(val) {
                this.filesDialogVisible = val
            }
        },
        pages () {
            let pages = []
            this.files.forEach((item, index) => {
                let page = Math.floor(index / 3)
                if (!pages[page]) {
                    pages[page] = []
                }
                pages[page].push(item)
            })
            return pages
        },
        
    }
}

</script>

<style scoped>
.el-dialog .main-title {
    font-size: 22px;
    color: #606266;
}

.input-error >>> input{
    border-color: red;
}
.teste {
    background-color: blue;
}
.header-container {
    text-align: center;
}
.danger {
    border-width: 1px;
    padding-top: 10px;
    padding-bottom: 12px;
    border-style: solid;
    width: 500px;
    border-color: red;
}
hr { 
    display: block;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
    margin-left: auto;
    margin-right: auto;
    border-style: inset;
    border-width: 1px;
}
.logo-in-form {
  vertical-align: middle;
  max-height: 100%;
  max-width: 100%;
}
.el-image >>> img {
    max-height: 148px;
    max-width: 240px;
}
div >>> .el-upload-dragger {
    width: auto;
    height: 80px;
}
.el-upload-dragger .el-icon-upload {
    margin: 0px;
    font-size: 35px;
}
.upload-text {
    position: relative;
    top: -15px;
    font-size: 12.5px;
}
.bigImage {
    height: 164px;
}
.danger-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.fields-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
}
a:link {
    text-decoration: inherit;
    color: inherit;
    cursor: auto;
}

a:visited {
    text-decoration: inherit;
    color: inherit;
    cursor: auto;
}
.detail-card {
    font-style: italic;
    font-size: small;
    float: right;
}
</style>